import React from 'react'
import { section } from 'framer-motion/client';
import { HICon } from '../components/GenericVerticalComponents/ProductUseCases';
import VerticalDetails from '../components/GenericVerticalComponents/VerticalDetails';
import { Helmet } from 'react-helmet-async';
import siteConfig from '../configuration/siteConfiguration';

const baseImageUrl = `${siteConfig.assetBaseUrl}/icons/manufacturing`;

const cardData = [
    {
        id: 1,
        title: 'AI-Powered Process Intelligence & Optimization',
        icon: `${baseImageUrl}/process-intelligence-icon.png`,
    },
    {
        id: 2,
        title: 'Digital Twins & Scenario Simulation',
        icon: `${baseImageUrl}/digital-twins-icon.png`,
    },
    {
        id: 3,
        title: 'Predictive Maintenance Intelligence',
        icon: `${baseImageUrl}/predictive-maintenance-icon.png`,
    },
    {
        id: 4,
        title: 'On-Premise & Local Private LLM',
        icon: `${baseImageUrl}/on-premise-llm-icon.png`,
    },
    {
        id: 5,
        title: 'Vision AI & Drone Analytics',
        icon: `${baseImageUrl}/vision-ai-drone-icon.png`,

    },
    {
        id: 6,
        title: 'Legacy-First Integration',
        icon: `${baseImageUrl}/legacy-integration-icon.png`,
    },
];

const benefits = [
    {
        title: "10–20% improvement in plant-wide energy efficiency",
        icon: "/images/countdown2.svg"
    },
    {
        title: "15–30% reduction in quality variability and process instability",
        icon: "/images/sidebaricons.svg"
    }
];

const manufacturingProdStats = [
    { value: "10-12%", description: "improvement in energy efficiency through cross-process optimization" },
    { value: "20–30%", description: "reduction in unplanned downtime with predictive maintenance insights" },
    { value: "10–15%", description: "improvement in throughput stability across critical plant operations" },
    { value: "90%+", description: "operator trust through explainable, constraint-aware recommendations" },
    { value: "Plant-scale", description: "visibility across inventory, processes, and equipment using Vision AI and analytics" },
    { value: "On-prem", description: "deployment ensuring full data sovereignty and low-latency decision support" },
];

const useCases = [
    {
        icon: <HICon icon="ai-powered-legal-research.svg" />,
        title: 'Process Intelligence & Digital Twins',
        summary: 'Understand, simulate, and optimize complex plant operations safely.',
        description: `Cognitva models and reasons over complex industrial processes using AI-powered process intelligence and digital twins. This allows teams to simulate scenarios, understand process behavior, and evaluate operational decisions safely before applying changes in live plant environments.`
    },
    {
        icon: <HICon icon="smart-client--matter-management.svg" />,
        title: 'Predictive Maintenance & Operational Intelligence',
        summary: 'Anticipate issues early. Reduce downtime with explainable insights.',
        description: `Cognitva identifies early equipment and process risk signals to support predictive maintenance and reliability planning.
Explainable insights help maintenance and operations teams reduce unplanned downtime while keeping humans in control of critical actions.
`
    },
    {
        icon: <HICon icon="role-play--virtual-courtroom-simulation.svg" />,
        title: 'Vision AI, Drone Analytics & Inventory Intelligence',
        summary: 'Gain accurate site and inventory visibility at plant scale.',
        description: `Cognitva applies Vision AI and drone analytics to deliver accurate visibility across large industrial sites and inventory-intensive operations.
This improves operational awareness and reduces manual inspections without disrupting plant workflows.
`
    },
    {
        icon: <HICon icon="role-play--virtual-courtroom-simulation.svg" />,
        title: 'Secure On-Prem AI Deployment',
        summary: 'Deploy AI inside the plant-without data leaving your control.',
        description: `Cognitva supports fully on-prem AI deployments, ensuring sensitive plant data never leaves enterprise control.
Local intelligence enables low-latency, secure decision support aligned with industrial security and compliance requirements.`
    },
    {
        icon: <HICon icon="role-play--virtual-courtroom-simulation.svg" />,
        title: 'Legacy Integration & Operator Decision Support',
        summary: 'AI that works with existing plant systems and workflows.',
        description: `Cognitva integrates with existing plant systems to augment, not replace, current operations.
Operators receive contextual, explainable insights within familiar workflows, supporting trust and safe adoption in live plants.`
    },
];


export default function ManufacturingProducts() {
    return (
        <>
            <Helmet>
                <title>CIP™ - Manufacturing</title>
                <meta name="description" content="CIP™ - Manufacturing" />
                <meta name="keywords" content="AI-powered process intelligence, predictive maintenance, digital twins, and Vision AI - all built for cement, heavy industry, and large-scale manufacturing operations." />
                <link rel="canonical" href="https://www.cognitva.ai/cip-manufacturing" />
                <meta property="og:title" content="CIP™ - Cross-Industry Intelligence Platform" />
                <meta property="og:description" content="AI-powered process intelligence, predictive maintenance, digital twins, and Vision AI - all built for cement, heavy industry, and large-scale manufacturing operations." />
                <meta property="og:url" content="https://www.cognitva.ai/cip-manufacturing" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://www.cognitva.ai/images/cip-logo.png" />
                <meta property="og:image:alt" content="CIP Logo" />
                <meta property="og:site_name" content="Cognitva Global Technologies Private Limited" />
            </Helmet>
            <div className='page_container'>
                <VerticalDetails
                    keyFeaturesCards={cardData}
                    mainSection={{
                        title: "COGNITVA CIP - Manufacturing",
                        subtitle: "Where Cognitva Manufacturing transforms plant operations",
                        description: "AI-powered process intelligence, predictive maintenance, digital twins, and Vision AI - all built for cement, heavy industry, and large-scale manufacturing operations.",
                        benefits: benefits
                    }}
                    productStats={manufacturingProdStats}
                    productUseCases={{
                        sectionTitle: "WHAT COGNITVA CIP-MANUFACTURING DOES",
                        sectionSubtitle: "Use Cases We Solve aa",
                        useCases: useCases
                    }}
                    requestInfoTitle={<>Powered by patent pending technology Cognitva CIP -Manufacturing,<br /> Cognitva automates, adapts, and scales across industries - transforming how enterprises work.</>}
                />
            </div>
        </>
    )
}
